// extracted by mini-css-extract-plugin
module.exports =  {"providers":"_33974c2b58--providers--g1KYe","img":"_33974c2b58--img--laY4u"};